module.exports = __webpack_public_path__ + "img/puregym-three-main.fe685bd7.png";